function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import { STORAGE_TYPES } from './types/storage.types';
import { load as storageLoad, save as storageSave, init as storageInit } from './storage';

let defaultKey;

//region API

export const init = (cbSuccess, key) => {
    defaultKey = key;
    storageInit();
    const cbFail = () => {
        clear();
        cbSuccess(getInitialState());
    };

    return storageLoad(defaultKey, cbSuccess, cbFail);
};

export const get = () => {
    const cbFail = error => {
        storageSave(defaultKey, getInitialState([error]));
    };
    return storageLoad(defaultKey, null, cbFail);
};

export const save = (() => {
    var _ref = _asyncToGenerator(function* (errors = []) {
        let dataFromStorage = {};
        try {
            dataFromStorage = yield get();
            const allErrors = [...dataFromStorage.errors, ...errors];
            return storageSave(defaultKey, getInitialState(allErrors));
        } catch (error) {
            switch (error.name) {
                case STORAGE_TYPES.ERROR_NOT_FOUND:
                case STORAGE_TYPES.ERROR_EXPIRED:
                    return storageSave(defaultKey, errors);
                    break;
                default:
                    throw error;
            }
        }
    });

    return function save() {
        return _ref.apply(this, arguments);
    };
})();

export const clear = () => {
    storageSave(defaultKey, getInitialState());
};

//endregion
//region private

const getInitialState = data => {
    return {
        errors: !data || !data.length ? [] : data
    };
};

//endregion


// WEBPACK FOOTER //
// ./~/pluton-core/lib/device/errors.storage.js